import { type BordersStyles, Box, Icon, Item, Text } from '@factorialco/deprecated-design-system'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

interface MappingTableProps<T> {
  title: string
  items: T[]
  options: Item[]
  getItemId: (item: T) => string
  getItemLabel: (item: T) => string
  onSelect: (value: Item, item: T) => void
  findSelection: (itemId: string) => string
  disabled?: boolean
  loading?: boolean
  selectPlaceholder?: string
  customBorder?: BordersStyles
}

export function MappingTable<T>({
  title,
  items,
  options,
  getItemId,
  getItemLabel,
  onSelect,
  findSelection,
  disabled = false,
  loading = false,
  selectPlaceholder,
  customBorder,
}: MappingTableProps<T>) {
  return (
    <Box
      border={customBorder || { all: { color: 'grey300', width: 's1', style: 'solid' } }}
      borderRadius={{ all: 'abs008' }}
      background={'white'}
    >
      <Box paddingX="s24" paddingY="s12" flexDirection="row" alignItems="center">
        <Text.Header3 color="grey800">
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.mapping_table.factorial_fields'
          )}
        </Text.Header3>
        <Box flexGrow></Box>
        <Box width="s300">
          <Text.Header3 color="grey800">{title}</Text.Header3>
        </Box>
      </Box>
      {items.map((item) => (
        <Box
          key={getItemId(item)}
          flexDirection="row"
          gap="s24"
          justifyContent="spaceBetween"
          border={{ top: { color: 'grey300', width: 's1', style: 'solid' } }}
          paddingX="s24"
          paddingY="s12"
          alignItems="center"
        >
          <Box flexGrow>
            <Box width="s200">
              <Text.Normal overflowWrap color="grey1000">
                {getItemLabel(item)}
              </Text.Normal>
            </Box>
          </Box>
          <Box>
            <Icon.Medium icon="arrow-right" />
          </Box>
          <Box width="s300">
            <DropdownSearchBar
              name={findSelection(getItemId(item))}
              placeholder={selectPlaceholder || i18n.t('common.select')}
              label=""
              onSelect={(value) => onSelect(value, item)}
              labelNotFound={i18n.t('common.none')}
              data={options}
              searchLabel={i18n.t('common.search')}
              autofocus={false}
              ellipsis={false}
              disabled={disabled}
              loading={loading}
            />
          </Box>
        </Box>
      ))}
    </Box>
  )
}
